import { API } from '../api/API';

const partenaireService = {
  // Récupérer tous les partenaires
  getAllPartenaires: async (page = 1, limit = 200, search = '') => {
    try {
      const response = await API.get('/partenaires', {
        params: { page, limit, search },
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des partenaires:', error);
      throw error;
    }
  },

  // Créer un nouveau partenaire
  createPartenaire: async (partenaireData) => {
    try {
      const response = await API.post('/partenaires', partenaireData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création du partenaire:", error);
      throw error;
    }
  },

  // Récupérer un partenaire par ID
  getPartenaireById: async (id) => {
    try {
      const response = await API.get(`/partenaires/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du partenaire:", error);
      throw error;
    }
  },

  // Mettre à jour un partenaire
  updatePartenaire: async (id, updateData) => {
    try {
      const response = await API.put(`/partenaires/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du partenaire:", error);
      throw error;
    }
  },

  // Supprimer un partenaire
  deletePartenaire: async (id) => {
    try {
      const response = await API.delete(`/partenaires/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la suppression du partenaire:", error);
      throw error;
    }
  },
};

export default partenaireService;
